import {Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {appearHeight, appearWidth} from '../../../kyloe-animations';

@Component({
    selector: 'app-chips',
    templateUrl: './chips.component.html',
    styleUrls: ['./chips.component.scss'],
    animations: [appearHeight, appearWidth],
    standalone: false
})
export class ChipsComponent {

  @Input()
  chips: string[] = [];

  @Input()
  set maxChips(value: number | undefined) {
    this._maxChips = value;
    this.placeholder = this.placeholder + ('Max' + this._maxChips);
  }

  @Input()
  placeholder = 'Enter value...';

  @Input()
  tooltip = 'The text to filter by';

  @Input()
  inputType = 'text'; // Equal to text or number.

  @Input()
  disabled = false;

  @Input()
  inline = false;

  @Output() addChipEmitter = new EventEmitter<string>();
  @Output() removeChipEmitter = new EventEmitter<string>();

  @ViewChild('chipInput') chipInput: ElementRef | undefined;

  addingChip = false;
  protected _maxChips: number | undefined;

  constructor() { }

  onAddChip(chip: string): void {
    chip = chip.trim();
    if (chip.length > 0 && !this.chips.find(c => c === chip)) {
      this.chips.push(chip);
      this.addingChip = true;
      setTimeout(() => { this.addingChip = false; }, 500);
      this.addChipEmitter.emit(chip);
      this.clearInput(this.chipInput?.nativeElement, true);
    }
  }

  onRemoveChip(chip: string): void {
    const index = this.chips.indexOf(chip);
    this.chips.splice(index, 1);
    this.removeChipEmitter.emit(chip);
  }

  clearInput(inputElement: HTMLElement, focusInput: boolean): void {
    const input = inputElement as HTMLInputElement;
    input.value = '';
    if (focusInput)
      inputElement.focus();
  }
}
